export default __webpack_public_path__ + "static/media/8-2.9b02a4a3.gif";